export default "__VITE_ASSET__$YE7WHMS__"